import React, {useEffect, useState} from 'react';
import { H1, UserContainer, OrderContainer, OrderName, OrderDate, CardsContainer, CardH2, CardInfo } from './style';
import axios from 'axios';
import AuthService from '../../../AuthService';
import { PaginationButton, PaginationContainer } from '../../Categories/style';
import { formatDate, formatDateTime } from '../../../Utils/Locale/locale';
import Card from '../../../Components/Miscellaneous/Card';
import { MdOutlineLocalShipping, MdOutlinePending, MdCheckCircle, MdCancel, MdShoppingBag, MdStorefront } from 'react-icons/md';
import { FaChevronLeft, FaChevronRight, FaEye, FaCalendarAlt, FaEuroSign, FaUser } from 'react-icons/fa';


export default function Orders() {

    const [orders, setOrders] = useState([]);
    const [ordersStatistics, setOrdersStatistics] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);
    const limit = 50; // Pedidos por página

    const fetchOrders = async (page = 1) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://api.rb.beeapp.es/admin/orders?page=${page}&limit=${limit}`, {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
            });
            
            const data = response.data;
            setOrders(data.results || []);
            setPagination(data.pagination || {});
            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching orders:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Cargar primera página de pedidos
        fetchOrders(1);

        // Cargar estadísticas (no necesitan paginación)
        axios.get('https://api.rb.beeapp.es/admin/orders/statistics', {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        }).then(response => {
            return response.data;
        })
        .then(data => {
            console.log(data);
        })
        .catch(error => {
            console.error(error);
        });

        axios.get('https://api.rb.beeapp.es/admin/orders/statistics/status', {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        }).then(response => {
            return response.data;
        })
        .then(data => {
            setOrdersStatistics(data);
        })
        .catch(error => {
            console.error(error);
        });
    }, []);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            fetchOrders(newPage);
        }
    };

    const renderPaginationControls = () => {
        if (!pagination.totalPages || pagination.totalPages <= 1) return null;

        const pageNumbers = [];
        const maxVisiblePages = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(pagination.totalPages, startPage + maxVisiblePages - 1);

        // Ajustar si estamos cerca del final
        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return (
            <PaginationContainer>
                <PaginationButton 
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                >
                    Primera
                </PaginationButton>
                
                <PaginationButton 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={!pagination.hasPrevious}
                >
                    <FaChevronLeft />
                </PaginationButton>

                {pageNumbers.map(page => (
                    <PaginationButton
                        key={page}
                        onClick={() => handlePageChange(page)}
                        style={{
                            backgroundColor: page === currentPage ? '#007bff' : 'transparent',
                            color: page === currentPage ? 'white' : '#007bff'
                        }}
                    >
                        {page}
                    </PaginationButton>
                ))}

                <PaginationButton 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={!pagination.hasNext}
                >
                    <FaChevronRight />
                </PaginationButton>

                <PaginationButton 
                    onClick={() => handlePageChange(pagination.totalPages)}
                    disabled={currentPage === pagination.totalPages}
                >
                    Última
                </PaginationButton>
            </PaginationContainer>
        );
    };

    const getStatusIcon = (status, isBarOffice) => {
        const color = isBarOffice ? '#1e40af' : '#028322';
        switch(status) {
            case 'Created':
                return <MdOutlinePending size={24} color="#f59e0b" />;
            case 'Preparing':
                return <MdShoppingBag size={24} color="#3b82f6" />;
            case 'Shipped':
                return <MdOutlineLocalShipping size={24} color={color} />;
            case 'Delivered':
                return <MdCheckCircle size={24} color={color} />;
            case 'Cancelled':
                return <MdCancel size={24} color="#ef4444" />;
            default:
                return <MdOutlinePending size={24} color="#6b7280" />;
        }
    };

    const formatOrderDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <UserContainer>
            <div style={{
                background: '#667eea',
                borderRadius: '16px',
                padding: '32px',
                marginBottom: '32px',
                color: 'white'
            }}>
                <H1 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '8px' }}>
                    📊 Gestión de Pedidos
                </H1>
                <p style={{ fontSize: '1.1rem', opacity: 0.9, margin: 0 }}>
                    Administra y supervisa todos los pedidos de tu plataforma
                </p>
            </div>

            <CardsContainer>
                <Card xs style={{ background: '#667eea', border: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                    <CardH2>Pedidos Totales</CardH2>
                            <CardInfo style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                                {ordersStatistics?.Total || 0}
                            </CardInfo>
                        </div>
                        <MdShoppingBag size={40} style={{ opacity: 0.8 }} />
                    </div>
                </Card>
                
                <Card xs style={{ background: '#f59e0b', border: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <CardH2 style={{ color: 'white' }}>Pendientes</CardH2>
                            <CardInfo style={{ fontSize: '2rem', fontWeight: 'bold', color: 'white' }}>
                                {ordersStatistics?.Created ?? 0}
                            </CardInfo>
                        </div>
                        <MdOutlinePending size={40} style={{ color: 'white', opacity: 0.8 }} />
                    </div>
                </Card>
                
                <Card xs style={{ background: '#10b981', border: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <CardH2 style={{ color: 'white' }}>Enviados</CardH2>
                            <CardInfo style={{ fontSize: '2rem', fontWeight: 'bold', color: 'white' }}>
                                {(ordersStatistics?.Shipped ?? 0) + (ordersStatistics?.Delivered ?? 0)}
                            </CardInfo>
                        </div>
                        <MdOutlineLocalShipping size={40} style={{ color: 'white', opacity: 0.8 }} />
                    </div>
                </Card>
                
                <Card xs style={{ background: '#ef4444', border: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <CardH2 style={{ color: 'white' }}>Cancelados</CardH2>
                            <CardInfo style={{ fontSize: '2rem', fontWeight: 'bold', color: 'white' }}>
                                {ordersStatistics?.Cancelled ?? 0}
                            </CardInfo>
                        </div>
                        <MdCancel size={40} style={{ color: 'white', opacity: 0.8 }} />
                    </div>
                </Card>
            </CardsContainer>

            {/* Información de paginación */}
            {pagination.totalOrders && (
                <div style={{
                    margin: '24px 0', 
                    padding: '16px 24px',
                    background: '#f8fafc',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    color: '#64748b', 
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <FaEye />
                    <span>
                        Mostrando {((currentPage - 1) * limit) + 1} - {Math.min(currentPage * limit, pagination.totalOrders)} de {pagination.totalOrders} pedidos
                    </span>
                </div>
            )}

            {/* Estado de carga */}
            {loading && (
                <div style={{
                    textAlign: 'center', 
                    padding: '40px',
                    background: '#f8fafc',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0'
                }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #e2e8f0',
                        borderTop: '4px solid #3b82f6',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 16px'
                    }}></div>
                    <p style={{ color: '#64748b', margin: 0 }}>Cargando pedidos...</p>
                </div>
            )}

            {/* Lista de pedidos mejorada */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {!loading && orders.length > 0 && orders.map((order, index) => {
                    // Determinar color según la sourceApp del pedido
                    const isBarOffice = order.sourceApp === 'BarOffice';
                    
                    return (
                        <div
                            key={order._id || index}
                            onClick={() => {
                            window.location.href = `/admin/order/${order._id}`;
                        }}
                            style={{
                                background: 'white',
                                borderRadius: '12px',
                                border: `2px solid ${isBarOffice ? '#3b82f6' : '#e2e8f0'}`,
                                padding: '24px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                position: 'relative'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.borderColor = isBarOffice ? '#1e40af' : '#10b981';
                                e.target.style.background = '#fafafa';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.borderColor = isBarOffice ? '#3b82f6' : '#e2e8f0';
                                e.target.style.background = 'white';
                            }}
                        >
                            {/* Badge de origen */}
                            {isBarOffice && (
                                <div style={{
                                    position: 'absolute',
                                    top: '16px',
                                    right: '16px',
                                    background: '#3b82f6',
                                    color: 'white',
                                    padding: '6px 12px',
                                    borderRadius: '16px',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}>
                                    <MdStorefront size={14} />
                                    BarOffice
                                </div>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div style={{ flex: 1 }}>
                                    {/* Header del pedido */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
                                        <div style={{
                                            width: '48px',
                                            height: '48px',
                                            background: isBarOffice ? '#3b82f6' : '#10b981',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white'
                                        }}>
                                            <FaUser size={20} />
                                        </div>
                                        <div>
                                            <h3 style={{
                                                margin: 0,
                                                fontSize: '1.25rem',
                                                fontWeight: '600',
                                                color: isBarOffice ? '#1e40af' : '#059669',
                                                fontFamily: 'Inter, sans-serif'
                                            }}>
                                                {order.UserID?.Name} {order.UserID?.Surname}
                                            </h3>
                                            <p style={{
                                                margin: 0,
                                                fontSize: '0.875rem',
                                                color: '#64748b'
                                            }}>
                                                Pedido #{order._id.slice(-8)}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Información del pedido */}
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{
                                                width: '36px',
                                                height: '36px',
                                                background: '#f1f5f9',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <FaCalendarAlt size={16} color="#64748b" />
                                            </div>
                                            <div>
                                                <p style={{ margin: 0, fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '500' }}>
                                                    Fecha
                                                </p>
                                                <p style={{ margin: 0, fontWeight: '600', color: '#1f2937', fontSize: '0.9rem' }}>
                                                    {formatOrderDate(order.CreationDate)}
                                                </p>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{
                                                width: '36px',
                                                height: '36px',
                                                background: '#f1f5f9',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <FaEuroSign size={16} color="#64748b" />
                                            </div>
                                            <div>
                                                <p style={{ margin: 0, fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '500' }}>
                                                    Total
                                                </p>
                                                <p style={{ margin: 0, fontWeight: '700', fontSize: '1.125rem', color: isBarOffice ? '#1e40af' : '#059669' }}>
                                                    {order.TotalAmount.toFixed(2).replace('.', ',')}€
                                                </p>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{
                                                width: '36px',
                                                height: '36px',
                                                background: '#f1f5f9',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <MdShoppingBag size={16} color="#64748b" />
                                            </div>
                                            <div>
                                                <p style={{ margin: 0, fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '500' }}>
                                                    Productos
                                                </p>
                                                <p style={{ margin: 0, fontWeight: '600', color: '#1f2937', fontSize: '0.9rem' }}>
                                                    {order.Products?.length || 0} artículo{order.Products?.length !== 1 ? 's' : ''}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Origen del pedido */}
                                    {(order.sourceApp || order.UserID?.organization) && (
                                        <div style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            background: isBarOffice ? '#eff6ff' : '#f0fdf4',
                                            color: isBarOffice ? '#1e40af' : '#059669',
                                            padding: '8px 14px',
                                            borderRadius: '8px',
                                            fontSize: '0.875rem',
                                            fontWeight: '600',
                                            border: `1px solid ${isBarOffice ? '#dbeafe' : '#dcfce7'}`
                                        }}>
                                            <MdStorefront size={16} />
                                            {order.sourceApp || order.UserID?.organization}
                                        </div>
                                    )}
                                </div>

                                {/* Estado del pedido */}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', marginLeft: '20px' }}>
                                    <div style={{
                                        width: '56px',
                                        height: '56px',
                                        background: '#f8fafc',
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '1px solid #e2e8f0'
                                    }}>
                                        {getStatusIcon(order.Status, isBarOffice)}
                                    </div>
                                    <span style={{
                                        fontSize: '0.875rem',
                                        fontWeight: '600',
                                        color: '#64748b',
                                        textAlign: 'center'
                                    }}>
                                        {order.Status === 'Created' ? 'Pendiente' : 
                                         order.Status === 'Preparing' ? 'Preparando' :
                                         order.Status === 'Shipped' ? 'Enviado' :
                                         order.Status === 'Delivered' ? 'Entregado' :
                                         order.Status === 'Cancelled' ? 'Cancelado' : order.Status}
                                    </span>
                                </div>
                            </div>

                            {/* Barra inferior de color */}
                            <div style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                height: '4px',
                                background: isBarOffice ? '#3b82f6' : '#10b981',
                                borderRadius: '0 0 10px 10px'
                            }}></div>
                        </div>
                    );
                })}
            </div>

            {/* Mensaje si no hay pedidos */}
            {!loading && orders.length === 0 && (
                <div style={{
                    textAlign: 'center', 
                    padding: '60px 40px',
                    background: 'white',
                    borderRadius: '12px',
                    border: '2px dashed #e2e8f0'
                }}>
                    <MdShoppingBag size={64} color="#cbd5e1" style={{ marginBottom: '16px' }} />
                    <h3 style={{ color: '#64748b', margin: '0 0 8px 0', fontWeight: '600' }}>No se encontraron pedidos</h3>
                    <p style={{ color: '#94a3b8', margin: 0 }}>No hay pedidos disponibles en este momento</p>
                </div>
            )}

            {/* Controles de paginación */}
            {renderPaginationControls()}

            <style jsx>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </UserContainer>
    );
}